import {Component, OnInit, OnDestroy} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs/Subscription';
import {EmissionService} from 'services/emission.service';
import {FooterNavbarService} from 'services/connectors/footer-navbar.service';
import {Constants} from 'config/constants';
import {SpinnerService} from 'services/spinner.service';
import {CustomValidators} from 'ng2-validation';

@Component({
    selector: 'tpc-individual-fuel',
    templateUrl: './individual-fuel.component.html',
    styleUrls: ['./individual-fuel.component.css']
})
export class IndividualFuelComponent implements OnInit, OnDestroy {
    private nextSub: Subscription;
    private isFormSubmitted = false;

    public fuelForm: FormGroup;
    private fuelTypeList = [
        {key: 'jetFuel', value: 'Jet Fuel'},
        {key: 'aviationGas', value: 'Aviation Gasoline'}
    ];

    constructor(protected fb: FormBuilder,
                private emissionService: EmissionService,
                private footerService: FooterNavbarService,
                private spinner: SpinnerService
    ) {
        this.nextSub = footerService.next$.subscribe(() => {
            this.isFormSubmitted = true;
            if (this.fuelForm.status === 'VALID') {
                this.next();
            }
        });

        this.createForm();
    }
    ngOnInit() {
    }

    private createForm(): void {
        this.fuelForm = this.fb.group({
            gallons: ['', [
                Validators.required,
                CustomValidators.min(1),
                CustomValidators.max(9999999),
                CustomValidators.digits] ],
            'fuel-type' : ['jetFuel', Validators.required ]
        });
    }

    private next(): void {
        let params = {
                calculateBy: 'byFuel',
                fuelGallon: this.getFV('gallons'),
                fuelType: this.getFV('fuel-type')
            },
            calculatorName = Constants.calculators.individual,
            categoryName = Constants.categories.individual.travel;

        this.spinner.show();
        this.emissionService.getEmissionValue(params, calculatorName, categoryName).subscribe(
            response => {
                let input = response.body[0].input[0];

                this.emissionService.setEmission({
                    category: categoryName,
                    emission: {
                        emission: input.emmission,
                        emissionTrees: input.emissionTrees,
                        DollarAmt: input.DollarAmt,
                        DollarAmtMonthly: input.DollarAmtMonthly
                    }
                });
                this.footerService.skip();
                this.spinner.hide();
            }
        );
    }


    checkError(param) {
        return this.fuelForm.get(param).status === 'INVALID' && (this.isFormSubmitted || this.fuelForm.get(param).touched);
    }

    getFV(param) {
        return this.fuelForm.get(param).value;
    }

    ngOnDestroy () {
        if (this.nextSub) {
            this.nextSub.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/individual-calculator/individual-travel/individual-fuel/individual-fuel.component.ts